import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

const useStylesBootstrap = makeStyles(theme => ({
  arrow: {
    color: theme.palette.common.black
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    fontSize: "12px"
  }
}));

function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();

  return <Tooltip arrow classes={classes} {...props} />;
}

function toolTip(props) {
  return Object.keys(props).includes("title") ? (
    <BootstrapTooltip {...props}>{props.children}</BootstrapTooltip>
  ) : (
    <React.Fragment>{props.children}</React.Fragment>
  );
}

export default toolTip;
